import axios from "../axios-auth";
import orginal_axios from "axios";

export const productService = {
  getProductList,
  saveProduct,
  getProductDetail,
  getProductsByStatus,
  getProductBySWC,
  getProductUnitByBarcode,
  getProductByCode,
  getAllProductList,
  saveproductExcel,
  getProductExcelTemplate,
  getProductExcelExport
};

function getProductList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.color) {
    params["color"] = searchParams.color;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.brandName) {
    params["brandName"] = searchParams.brandName;
  }
  if (searchParams.categoryName) {
    params["categoryName"] = searchParams.categoryName;
  }
  if (searchParams.categoryId) {
    params["categoryId"] = searchParams.categoryId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.productGroupName) {
    params["productGroupName"] = searchParams.productGroupName;
  }
  if (searchParams.productGroupCode) {
    params["productGroupCode"] = searchParams.productGroupCode;
  }
  if (searchParams.productGroupStatus) {
    params["pgStatus"] = searchParams.productGroupStatus;
  }
  if (searchParams.isSaleUnit) {
    params["isSaleUnit"] = searchParams.isSaleUnit;
  }
  if (searchParams.currencyId) {
    params["currencyId"] = searchParams.currencyId;
  }
  return axios.get("/auth/products", { params });
}

function saveProduct(product) {
  if (!product.id) {
    // new product
    return axios.post("/auth/product", product);
  } else {
    // edit
    return axios.put("/auth/product", product);
  }
}

function getProductDetail(id) {
  return axios.get("/auth/product/" + id);
}

function getProductsByStatus(status) {
  return axios.get("/auth/products-by-status/" + status);
}

function getProductBySWC(status, warehouseId, categoryId) {
  let params = {};
  params["status"] = status;
  params["warehouseId"] = warehouseId;
  params["categoryId"] = categoryId;
  return axios.get("/auth/products", { params })
}

function getProductUnitByBarcode(barcode,currencyId) {
  let params = {};
  params["barcode"] = barcode;
  params["currencyId"] = currencyId;
  return axios.get("/auth/product-unit-by-barcode/", { params });
}

function getProductByCode(code, isSaleUnit, currencyId) {
  return axios.get("/auth/product-by-code/" + code +"/" + isSaleUnit + "/" + currencyId) ;
}

function saveproductExcel(file) {
  return axios.post('/auth/product-excel',
    file,
    {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

function getProductExcelTemplate() {
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/product-excel-template",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getProductExcelExport(searchParams) {
  let params = {
  };
  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.color) {
    params["color"] = searchParams.color;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.brandName) {
    params["brandName"] = searchParams.brandName;
  }
  if (searchParams.categoryName) {
    params["categoryName"] = searchParams.categoryName;
  }
  if (searchParams.categoryId) {
    params["categoryId"] = searchParams.categoryId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.productGroupName) {
    params["productGroupName"] = searchParams.productGroupName;
  }
  if (searchParams.productGroupCode) {
    params["productGroupCode"] = searchParams.productGroupCode;
  }
  if (searchParams.productGroupStatus) {
    params["pgStatus"] = searchParams.productGroupStatus;
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/product-excel-export",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
  }).then(function (response) {
    return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
  });
}

function getAllProductList(searchParams) {
  let params = {
  };
  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.color) {
    params["color"] = searchParams.color;
  }
  if (searchParams.status) {
    params["status"] = searchParams.status;
  }
  if (searchParams.brandName) {
    params["brandName"] = searchParams.brandName;
  }
  if (searchParams.categoryName) {
    params["categoryName"] = searchParams.categoryName;
  }
  if (searchParams.categoryId) {
    params["categoryId"] = searchParams.categoryId;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.productGroupName) {
    params["productGroupName"] = searchParams.productGroupName;
  }
  if (searchParams.productGroupCode) {
    params["productGroupCode"] = searchParams.productGroupCode;
  }
  if (searchParams.productGroupStatus) {
    params["pgStatus"] = searchParams.productGroupStatus;
  }
  return axios.get("/auth/products", { params });
}